// this file is automatically generated by git.revision.js script
export const versions = { revision: '83d1db9dd4' }; 
 //expose the commit hash to the window object 
//@ts-ignore 
window.rd_version = '83d1db9dd4';
